/*
* connected to: renderInput

* props that can pass to this component
  default is the text component   
  type=[date,dropdown,multi,textArea,mask]

* for all

  disabled
  label,
  error,
  helpText,
  leftIcon,
  rightIcon,
  onSubmit,
  onCancel,
  onClickLeft,
  onClickRight,
  small,large,(may be this dot working depending on outside div. ex-> if it has fixed width)
  id,
  name,
  type,
  placeholder,
  onChange,
  value,
  tooltip,
  tooltipPosition,

* for date picker  

  dateFormat,

* for drop down

  options=[name,code,src],
  filterBy,
  optionLabel

  if time
    useTimeStep(steps) and get time range
    filterBy='time'
  
* for multi

  chip

* for textArea

  cols
  rows
  autoResize

* for mask

  mask(numbers :9, text:a)

*/
import React from "react";
import { Button } from "primereact/button";
import RenderInput from "../common/RenderInput";

const inputContainer = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
};

const btnContainer = {
  gap: 5,
  display: "flex",
  justifyContent: "flex-end",
  position: "absolute",
  right: 0,
};

const zIndex = 1;

const AppInput = React.forwardRef((props, ref) => {
  const {
    label,
    error,
    small,
    large,
    helpText,
    leftIcon,
    onSubmit,
    onCancel,
    rightIcon,
    floatLabel,
    onClickLeft,
    onClickRight,
    ...rest
  } = props;

  const renderIcon = (onClick, icon) => (
    <i
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        zIndex,
        width: 15,
        height: 20,
        marginTop: -3,
      }}
    >
      {icon}
    </i>
  );

  const renderButton = (onClick, type) => (
    <Button
      onClick={onClick}
      icon={`pi pi-${type}`}
      className={`p-button${small && `-sm`}${large && `-lg`}`}
    />
  );

  const renderHelpText = () => (
    <small
      id="username1-help"
      style={{ color: !error && "#888" }}
      className={`p-d-block ${error && `p-invalid`}`}
    >
      {helpText ? helpText : "\u00a0"}
    </small>
  );

  return (
    <div className="bxt" style={inputContainer}>
      {!floatLabel && label && (
        <label
          htmlFor={label}
          className="p-d-block"
          style={{ color: "#888", marginBottom: 2 }}
        >
          {label}
        </label>
      )}

      <span
        className={`${leftIcon && `p-input-icon-left`} ${
          rightIcon && `p-input-icon-right`
        }`}
      >
        {leftIcon && renderIcon(onClickLeft, leftIcon)}
        {rightIcon && renderIcon(onClickRight, rightIcon)}
        <RenderInput ref={ref} {...props} {...rest} />
      </span>
      <div className="btns" style={{ position: "relative" }}>
        <div style={btnContainer}>
          {onSubmit && renderButton(onSubmit, "check")}
          {onCancel && renderButton(onCancel, "times")}
        </div>
      </div>

      {renderHelpText()}
    </div>
  );
});

export default AppInput;
